import React, { useState } from 'react';
import questions from '../questions';

const Questions = () => {
  const [filteredQuestions, setFilteredQuestions] = useState(questions);

  // Filter + sort
  const filterQuestions = (position) => {
    if (position === 'All') return questions;
    const filtered = questions.filter((q) => q.position === position);
    return filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
  };

  // Format date as Month Day
  const formatDate = (dateString) => {
    const options = { month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handlePositionFilter = (position) => {
    setFilteredQuestions(filterQuestions(position));
  };

  return (
    <div className='max-w-6xl mx-auto p-6'>
      <h2 className='text-3xl font-bold text-center mb-6 text-blue-700'>
        2025 Interview Questions
      </h2>

      {/* Filter buttons */}
      <div className='flex flex-wrap justify-center gap-3 mb-6'>
        <button
          onClick={() => handlePositionFilter('All')}
          className='bg-gray-500 hover:bg-gray-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md'
        >
          All
        </button>
        <button
          onClick={() => handlePositionFilter('Cybersecurity')}
          className='bg-green-500 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md'
        >
          Cybersecurity
        </button>
        <button
          onClick={() => handlePositionFilter('Frontend')}
          className='bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md'
        >
          Frontend
        </button>
        <button
          onClick={() => handlePositionFilter('Automation Test Engineer')}
          className='bg-yellow-500 hover:bg-yellow-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md'
        >
          QA Engineer
        </button>
      </div>

      {/* Questions table */}
      <div className='overflow-x-auto shadow-xl rounded-lg border border-gray-300'>
        <table className='min-w-full bg-white border border-gray-300'>
          <thead className='bg-blue-700 text-white'>
            <tr>
              <th className='py-3 px-4 text-left'>Position</th>
              <th className='py-3 px-4 text-left'>Question</th>
              <th className='py-3 px-4 text-left'>Company</th>
              <th className='py-3 px-4 text-left'>Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredQuestions.map((q, index) => (
              <tr
                key={index}
                className={
                  index % 2 === 0
                    ? 'bg-gray-50 hover:bg-blue-50'
                    : 'bg-white hover:bg-blue-50'
                }
              >
                <td className='py-3 px-4 border-t border-gray-200 font-medium text-blue-600'>
                  {q.position}
                </td>
                <td className='py-3 px-4 border-t border-gray-200 text-green-600'>
                  {q.question}
                </td>
                <td className='py-3 px-4 border-t border-gray-200 text-yellow-600'>
                  {q.company}
                </td>
                <td className='py-3 px-4 border-t border-gray-200 text-pink-600'>
                  {formatDate(q.date)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Questions;
